import React from 'react';
import { FieldArray } from 'redux-form';
import { Alias } from 'pages/Search/models';
import { Individuals } from '../';
import { Button, Divider, Tooltip } from 'antd';

const ButtonGroup = Button.Group;

const Aliases: any = ({ fields, meta: { error }, handleFieldFocus }: any) => {
  const addLimit = 4;
  const removeLimit = 1;

  return (
    <>
      {fields.map((alias: Alias, index: number) => {
        const fieldArrayName = `${alias}.items`;
        return (
          <section key={index}>
            <FieldArray
              name={fieldArrayName}
              component={Individuals}
              handleFieldFocus={handleFieldFocus}
            />
            <ButtonGroup>
              <Tooltip title={`Remove Name`}>
                <Button
                  tabIndex={-1}
                  type="danger"
                  size="small"
                  icon="minus"
                  onClick={() => fields.remove(index)}
                  disabled={fields.length === removeLimit}
                >
                  Remove Name
                </Button>
              </Tooltip>
              {fields.length - 1 === index && (
                <Tooltip title={`Add Name (the limit is ${addLimit} names)`}>
                  <Button
                    tabIndex={-1}
                    type="primary"
                    size="small"
                    icon="plus"
                    onClick={() =>
                      fields.push({ items: [{ firstName: '', lastName: '' }] })
                    }
                    disabled={fields.length >= addLimit}
                  >
                    Add Name
                  </Button>
                </Tooltip>
              )}
            </ButtonGroup>
            <Divider dashed />
          </section>
        );
      })}
    </>
  );
};

export default Aliases;
